import { randHexStr } from "lib/modules/util";

let visitorId = localStorage.getItem("visitorId");

if (!visitorId) {
	visitorId = randHexStr(8);
	localStorage.setItem("visitorId", visitorId);
}

const userId = document.currentScript.dataset.userId;
const urlref = document.referrer.startsWith(location.origin) ? "" : document.referrer;

const params = {
	idsite: 1,
	rec: 1,
	apiv: 1,
	send_image: 0,
	_id: visitorId,
	url: location.origin + document.currentScript.dataset.uri,
	...urlref && { urlref },
	res: `${screen.width}x${screen.height}`,
	dimension1: document.currentScript.dataset.locale,
	...userId && { dimension2: userId }
};

function sendAnalytics(customParams) {
	const date = new Date();
	const blob = new Blob([new URLSearchParams({
		...params,
		rand: date.getTime(),
		h: date.getHours(),
		m: date.getMinutes(),
		s: date.getSeconds(),
		...customParams
	})], { type: "application/x-www-form-urlencoded; charset=UTF-8" });

	navigator.sendBeacon("https://vixly.matomo.cloud/matomo.php", blob);
}

window.$vixAnalytics = (customParams = {}) => {
	try {
		sendAnalytics(customParams);
	}
	catch (e) {
		console.log(e);
	}
};

$vixAnalytics();

// Google tag (gtag.js)
window.dataLayer = window.dataLayer || [];

export function gtag() {
	if (location.hostname.toLowerCase() === "www.vixly.com")
		window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}

gtag("js", new Date());
gtag("config", "G-7M0M6L80W7");

window.vixAnalytics = { gtag };
